import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownAltComponent } from './dropdown-alt.component';
import { WmTransitionModule } from '../transition/index';
import { WmCardModule } from '../card/index';
import { WmSelectModule } from '../select/index';
import { FormsModule } from '@angular/forms';

@NgModule({
	declarations: [DropdownAltComponent],
	imports: [CommonModule, WmTransitionModule, WmCardModule, WmSelectModule, FormsModule],
	exports: [DropdownAltComponent]
})
export class WmDropdownAltModule {}
